import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import 'dayjs/locale/ru';

dayjs.extend(isToday);

export function getDayRange(
  from: string,
  to: string,
  fullWeeks: boolean = false,
  format: string = 'YYYY-MM-DDTHH:mm'
) {
  const list = [];
  let current = dayjs(from);
  let end = dayjs(to);

  if (fullWeeks && current.day() > 1) {
    current = current.subtract(current.day() - 1, 'day');
  }

  if (fullWeeks && end.day() !== 0) {
    end = end.add(7 - end.day(), 'day');
  }

  while (current.isBefore(end, 'day')) {
    list.push(current.format(format));
    current = current.add(1, 'day');
  }

  list.push(end.format(format));

  return list;
}

export function getDefaultDateFromat(date: string) {
  return dayjs(date).format('DD MMMM YYYY');
}

export function getDefaultTimeFromat(date: string) {
  return dayjs(date).format('HH:mm');
}

export function getCalendarSlot(date: string) {
  return {
    month: dayjs(date).locale('ru').format('MMM'),
    dayOfMonth: dayjs(date).locale('ru').format('DD'),
    dayOfWeek: dayjs(date).locale('ru').format('dd'),
    isToday: dayjs(date).isToday()
  };
}

export function isSameDay(date1: string, date2: string) {
  return dayjs(date1).isSame(dayjs(date2), 'day');
}

export function getCurrentWeekDay() {
  return dayjs().day();
}
